import type { ReactElement } from 'react';
import classnames from 'classnames';
import { cloneElement } from 'react';

interface IButtonContainerProps {
    buttons: ReactElement<{ key: number | string }>[];
    layout?: 'start-justified ' | 'center-justified' | 'end-justified';
    wrap?: boolean;
}

export function ButtonContainer(props: IButtonContainerProps) {
    let className = 'btn-container layout';

    if (props.layout) {
        className += ` ${props.layout}`;
    }
    if (props.wrap) {
        className += ' horizontal-wrap';
    }

    return (
        <div className={classnames(className)}>
            {props.buttons &&
                props.buttons.map((button, i) => cloneElement(button, { key: button.key ? String(button.key) : i }))}
        </div>
    );
}
